import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    lastObjects: []
});

export default (state = initialState(), action) => {
    switch (action.type) {
        case ActionTypes.SET_LAST_OBJECTS:
            return {...state, lastObjects: action.payload};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/HomePage.js